﻿import * as React from 'react';
import moment from 'moment';
import { Col } from 'react-bootstrap';
import { Translate } from '../../../../../../shared/LanguageService';
import * as Features from '../../../../../../shared/Features';
import { AuthenticatedUser } from '../../../../../../shared/types';

type ScandphotosPhotographerBookingInfoProps = {
    user: AuthenticatedUser;
    bookedTime: Date;
    photographerName: string;
};

function ScandphotosPhotographerBookingInfo({
    user,
    photographerName,
    bookedTime
}: ScandphotosPhotographerBookingInfoProps) {
    return (
        <Col sm={6}>
            <dt>{Translate('view-order/basic-order-info/titles/photographer')}</dt>
            <dd>
                <i style={{ marginRight: '6px' }} className="material-icons">
                    photo_camera
                </i>
                {Features.hasFeature(
                    Features.ViewBookedScandphotoPhotographerInfoRegardlessTime,
                    user
                ) || moment(bookedTime).diff(moment(), 'hours', true) < 24 ? (
                    photographerName
                ) : (
                    <i className="blur">
                        {Translate('view-order/basic-order-info/photographer/will-be-revealed')}
                    </i>
                )}
            </dd>
        </Col>
    );
}

export default ScandphotosPhotographerBookingInfo;
